export interface RouteItem {
  label: string;
  path: string;
}

export const routes: RouteItem[] = [
  { label: 'Dashboard', path: '/portal/dashboard' },
  { label: 'Admin Dashboard', path: '/portal/admin-dashboard' },
  { label: 'Quality Roadmap', path: '/portal/quality-roadmap' },
  { label: 'Audit Management', path: '/portal/audit' },
  { label: 'Training Dashboard', path: '/portal/training' },
  {
    label: 'Training Lesson Page',
    path: '/portal/training/:trainingId/version/:trainingVersionId'
  },
  {
    label: 'Training Lesson Page (with User)',
    path: '/portal/training/:trainingId/version/:trainingVersionId/user/:userId'
  },
  { label: 'Training Admin', path: '/portal/admin/training' },
  { label: 'Trainees', path: '/portal/admin/trainees' },
  { label: 'Trainee Detail', path: '/portal/admin/trainee/:userId/detail' },
  // { label: 'Training Admin Board', path: '/portal/admin/training-board' },
  {
    label: 'Training Admin Detail',
    path: '/portal/admin/training/task/:taskId'
  },
  { label: 'Risk Management', path: '/portal/risk' },
  { label: 'Risk Detail', path: '/portal/risks/task/:taskId' },
  { label: 'Document List', path: '/portal/documents' },
  {
    label: 'Document List (Folder)',
    path: '/portal/documents/folder/:folderId'
  },
  { label: 'Document Detail', path: '/portal/documents/file/task/:taskId' },
  // { label: 'Document Board', path: '/portal/document-board' },
  { label: 'Product List', path: '/portal/products' },
  {
    label: 'Product User Need Document',
    path: '/portal/products/:productId/user-needs'
  },
  {
    label: 'Product User Need Detail',
    path: '/portal/products/:productId/user-needs/:userNeedId'
  },
  {
    label: 'Product Design Input Document',
    path: '/portal/products/:productId/design-inputs'
  },
  {
    label: 'Product Design Input Detail',
    path: '/portal/products/:productId/design-inputs/:designInputId'
  },
  {
    label: 'Product Design Output Document',
    path: '/portal/products/:productId/design-outputs'
  },
  {
    label: 'Product Design Output Detail',
    path: '/portal/products/:productId/design-outputs/:designOutputId'
  },
  {
    label: 'Product Verification Document',
    path: '/portal/products/:productId/verifications'
  },
  {
    label: 'Product Verification Detail',
    path: '/portal/products/:productId/verifications/:verificationId'
  },
  {
    label: 'Product Validation Document',
    path: '/portal/products/:productId/validations'
  },
  {
    label: 'Product Validation Detail',
    path: '/portal/products/:productId/validations/:validationId'
  },
  {
    label: 'Product Design Spec Detail',
    path: '/portal/products/:productId/design-specs/:designSpecId'
  },
  { label: 'Product', path: '/portal/products/:productId/:view?' },
  {
    label: 'Hazard',
    path: '/portal/products/:productId/hazards/:hazardId/:view?'
  },
  {
    label: 'Hazard Cause Detail',
    path: '/portal/products/:productId/hazards/:hazardId/causes/:causeId'
  },
  {
    label: 'Hazard Control Detail',
    path: '/portal/products/:productId/hazards/:hazardId/controls/:controlId'
  },
  {
    label: 'Hazard Action Detail',
    path: '/portal/products/:productId/hazards/:hazardId/actions/:actionId'
  },
  { label: 'CAPA List', path: '/portal/capa' },
  { label: 'CAPA Detail', path: '/portal/capa/task/:taskId' },
  { label: 'SCAR List', path: '/portal/scar/' },
  { label: 'SCAR Detail', path: '/portal/scar/task/:taskId' },
  { label: 'Change Order List', path: '/portal/change-order/' },
  { label: 'Change Order Detail', path: '/portal/change-order/task/:taskId' },
  { label: 'Employees', path: '/portal/users' },
  { label: 'User Profile', path: '/portal/user-profile' },
  { label: 'Employee Detail', path: '/portal/users/:userId' },
  { label: 'Team Detail', path: '/portal/groups/:groupId' },
  { label: 'Teams', path: '/portal/groups' },
  { label: 'Supplier Management', path: '/portal/suppliers' },
  { label: 'Supplier Detail', path: '/portal/suppliers/task/:taskId' },
  { label: 'Purchase Order Detail', path: '/portal/spors/task/:taskId' },
  { label: 'Purchase Order Form', path: '/portal/purchase/form/:taskId' },
  { label: 'Workflow', path: '/portal/admin/workflow' },
  { label: 'Workflow Detail', path: '/portal/admin/workflow/:workflowId' },
  { label: 'Task Types', path: '/portal/admin/task-types' },
  { label: 'Task Type Detail', path: '/portal/admin/task-types/:name' },
  { label: 'Templates', path: '/portal/admin/templates' },
  { label: 'Agreements', path: '/portal/admin/agreements' },
  { label: 'Agreement Detail', path: '/portal/admin/agreements/:agreementId' },
  { label: 'Form Templates', path: '/portal/admin/form-templates' },
  {
    label: 'Form Template Detail',
    path: '/portal/admin/form-templates/:formTemplateId'
  },
  { label: 'JIRA', path: '/portal/jira' },
  { label: 'JIRA Issue', path: '/portal/jira/:issueId' },
  { label: 'JIRA Connect', path: '/portal/jira-connect' }
  // { label: 'Sign Up', path: '/portal/admin/signups' },
  // { label: 'Sign Up Detail', path: '/portal/admin/signups/:id' }
];
